export const types = {
  CLOSE: 'common/drawers/webhookCreateEditDrawer/CLOSE',
  OPEN: 'common/drawers/webhookCreateEditDrawer/OPEN',
};

export const webhookCreateEditDrawer = {
  close: () => ({
    type: types.CLOSE,
  }),
  open: ({ managedIntegrationUuid, webhookUuid, isEditing }) => ({
    type: types.OPEN,
    payload: {
      managedIntegrationUuid,
      webhookUuid,
      isEditing,
    },
  }),
};
